// actions.ts (в каталоге page)
import {
  FETCH_INVESTMENT_DATA,
  GET_INVESTMENT_COLLECTION,
  InvestmentColectionActions,
  SET_INVESTMENT_COLLECTION_FILTER,
} from './types'

export const getInvestmentCollection = (
  name: string
): InvestmentColectionActions => ({
  type: GET_INVESTMENT_COLLECTION,
  payload: name,
})

export const setInvestmentCollectionFilter = (
  params: string,
  name: string,
  currentCity: string
): InvestmentColectionActions => ({
  type: SET_INVESTMENT_COLLECTION_FILTER,
  payload: { params, name, currentCity },
})

// export const fetchInvestData = (params: string) => ({
//   type: FETCH_INVESTMENT_DATA,
//   payload: params,
// })
